"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();

import type React from "react";
import {useEffect, useRef} from "react";
import {getClientSideURL} from "@/utilities/getURL";
import {cn} from "@/utilities/ui";
import type {Props as MediaProps} from "../types";

export const VideoMedia: React.FC<MediaProps> = (props) => {
	const { onClick, resource, videoClassName } = props;

	const videoRef = useRef<HTMLVideoElement>(null);
	// const [showFallback] = useState<boolean>()

	useEffect(() => {
		const { current: video } = videoRef;
		if (video) {
			video.addEventListener("suspend", () => {
				// setShowFallback(true);
				// console.warn('Video was suspended, rendering fallback image.')
			});
		}
	}, []);

	if (resource && typeof resource === "object") {
		const { url, mimeType } = resource;

		// Use poster image if available (uploaded via CMS)
		const posterResource =
			resource.posterImage && typeof resource.posterImage === "object"
				? resource.posterImage
				: null;
		const posterUrl = posterResource?.url
			? posterResource.url.startsWith("http")
				? posterResource.url
				: `${getClientSideURL()}${posterResource.url}`
			: undefined;

		return (
			<video
				autoPlay
				className={cn(videoClassName)}
				controls={false}
				loop
				muted
				onClick={onClick}
				playsInline
				poster={posterUrl}
				preload="metadata"
				ref={videoRef}
			>
				<source
					src={url?.startsWith("http") ? url : `${getClientSideURL()}${url}`}
					type={mimeType || undefined}
				/>
			</video>
		);
	}

	return null;
};
